/* API module for KundeController */

import { api } from './http';
import { toApiError } from './errors';
import type {
  KundeCreateRequestDTO,
  KundeResponseDTO,
  KundeUpdateRequestDTO,
} from './types';

export type Id = number;

export async function getAll(): Promise<KundeResponseDTO[]> {
  try {
    const { data } = await api.get<KundeResponseDTO[]>('Kunde');
    return data;
  } catch (e) {
    throw toApiError(e);
  }
}

export async function getById(id: Id): Promise<KundeResponseDTO> {
  try {
    const { data } = await api.get<KundeResponseDTO>(`Kunde/${id}`);
    return data;
  } catch (e) {
    throw toApiError(e);
  }
}

export async function create(payload: KundeCreateRequestDTO): Promise<KundeResponseDTO> {
  try {
    const { data } = await api.post<KundeResponseDTO, KundeCreateRequestDTO>('Kunde', payload);
    return data;
  } catch (e) {
    throw toApiError(e);
  }
}

export async function update(id: Id, payload: KundeUpdateRequestDTO): Promise<KundeResponseDTO> {
  try {
    const { data } = await api.put<KundeResponseDTO, KundeUpdateRequestDTO>(`Kunde/${id}`, payload);
    return data;
  } catch (e) {
    throw toApiError(e);
  }
}

export async function remove(id: Id): Promise<void> {
  try {
    await api.delete<void>(`Kunde/${id}`);
  } catch (e) {
    throw toApiError(e);
  }
}
